export const UPDATE_VERSION = 'UPDATE_VERSION'
